import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../../api/mockData';
import './index.css';
const WritePost = () => {
  const navigate = useNavigate();
  const [title, setTitle] = useState('');
  const [excerpt, setExcerpt] = useState('');
  const [content, setContent] = useState('');
  const [category, setCategory] = useState('日常趣事');
  const [tags, setTags] = useState('');
  const [coverImage, setCoverImage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [categories, setCategories] = useState([]);

 useEffect(() => {
    // 检查 localStorage 中是否有用户信息
    const currentUser = localStorage.getItem('cat_blog_current_user');
    if (!currentUser) {
      navigate('/auth');
    }
  }, [navigate]);
  // 获取分类列表
  useEffect(() => {
    const fetchCategories = async () => {
      const response = await api.getCategories();
      if (response.success) {
        setCategories(response.data);
      }
    };
    fetchCategories();
  }, []);

  // 处理标签输入
  const handleTagsChange = (e) => {
    setTags(e.target.value);
  };

  // 处理图片上传（模拟）
  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (file) {
      // 模拟图片上传过程
      setIsSubmitting(true);
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // 这里应该是真实的上传逻辑，我们使用模拟URL
      const mockUrl = `https://images.unsplash.com/photo-${Math.floor(Math.random() * 1000)}?w=1200&h=600&fit=crop`;
      setCoverImage(mockUrl);
      setIsSubmitting(false);
    }
  };

  // 提交文章
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!title.trim() || !content.trim()) {
      alert('请填写标题和内容');
      return;
    }

    setIsSubmitting(true);

    try {
      const postData = {
        title,
        excerpt: excerpt || title,
        content,
        category,
        tags: tags.split(',').map(tag => tag.trim()).filter(tag => tag),
        coverImage: coverImage || `https://images.unsplash.com/photo-${Math.floor(Math.random() * 1000)}?w=1200&h=600&fit=crop`,
        authorId: 1
      };

      const response = await api.createPost(postData);
      
      if (response.success) {
        alert('文章发布成功！');
        navigate(`/post/${response.data.id}`);
      }
    } catch (error) {
      console.error('发布失败:', error);
      alert('发布失败，请重试');
    } finally {
      setIsSubmitting(false);
    }
  };

  // 编辑器工具栏
  const EditorToolbar = ({ onFormat }) => (
    <div className="editor-toolbar">
      <button type="button" onClick={() => onFormat('h2', '# ')}>H2</button>
      <button type="button" onClick={() => onFormat('h3', '## ')}>H3</button>
      <button type="button" onClick={() => onFormat('bold', '**粗体**')}>B</button>
      <button type="button" onClick={() => onFormat('italic', '*斜体*')}>I</button>
      <button type="button" onClick={() => onFormat('list', '- 列表项')}>List</button>
      <button type="button" onClick={() => onFormat('quote', '> 引用')}>Quote</button>
      <button type="button" onClick={() => onFormat('code', '`代码`')}>Code</button>
    </div>
  );

  // 格式文本
  const formatText = (format, sample) => {
    const textarea = document.getElementById('content-editor');
    if (!textarea) return;

    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const selectedText = content.substring(start, end);
    
    let newText;
    if (selectedText) {
      newText = content.substring(0, start) + sample.replace('text', selectedText) + content.substring(end);
    } else {
      newText = content.substring(0, start) + sample + content.substring(start);
    }
    
    setContent(newText);
    
    // 聚焦并恢复光标位置
    setTimeout(() => {
      textarea.focus();
      textarea.setSelectionRange(start + sample.length, start + sample.length);
    }, 0);
  };

  return (
    <div className="write-post-container">
      <div className="write-post-header">
        <h1 className="write-post-title">
          <span className="title-icon">✍️</span>
          撰写新文章
        </h1>
        <p className="write-post-subtitle">分享你的猫咪故事和经验</p>
      </div>

      <form className="write-post-form" onSubmit={handleSubmit}>
        {/* 标题输入 */}
        <div className="form-section">
          <label className="form-label">
            <span className="label-icon">📝</span>
            文章标题
          </label>
          <input
            type="text"
            className="form-input title-input"
            placeholder="输入吸引人的标题..."
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
          />
        </div>

        {/* 封面图片 */}
        <div className="form-section">
          <label className="form-label">
            <span className="label-icon">🖼️</span>
            封面图片
          </label>
          <div className="cover-upload-area">
            {coverImage ? (
              <div className="cover-preview">
                <img src={coverImage} alt="封面预览" />
                <button 
                  type="button" 
                  className="change-cover-btn"
                  onClick={() => setCoverImage('')}
                >
                  更换图片
                </button>
              </div>
            ) : (
              <label className="upload-label">
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleImageUpload}
                  style={{ display: 'none' }}
                />
                <div className="upload-placeholder">
                  <span className="upload-icon">📷</span>
                  <p>点击上传封面图片</p>
                  <p className="upload-hint">建议尺寸 1200x600px</p>
                </div>
              </label>
            )}
            {isSubmitting && (
              <div className="upload-progress">
                <div className="progress-bar"></div>
                <p>上传中...</p>
              </div>
            )}
          </div>
        </div>

        {/* 分类选择 */}
        <div className="form-section">
          <label className="form-label">
            <span className="label-icon">🏷️</span>
            分类
          </label>
          <div className="category-selector">
            {categories.map(cat => (
              <button
                key={cat.name}
                type="button"
                className={`category-option ${category === cat.name ? 'selected' : ''}`}
                onClick={() => setCategory(cat.name)}
              >
                <span className="category-emoji">{cat.emoji}</span>
                {cat.name}
              </button>
            ))}
          </div>
        </div>

        {/* 标签输入 */}
        <div className="form-section">
          <label className="form-label">
            <span className="label-icon">🔖</span>
            标签
          </label>
          <input
            type="text"
            className="form-input"
            placeholder="输入标签，用逗号分隔（如：喂养,健康,日常）"
            value={tags}
            onChange={handleTagsChange}
          />
          <div className="tag-suggestions">
            <span className="suggestion-label">常用标签：</span>
            {['喂养', '健康', '日常', '训练', '玩具', '护理'].map(tag => (
              <button
                key={tag}
                type="button"
                className="tag-suggestion"
                onClick={() => {
                  const currentTags = tags ? tags.split(',').map(t => t.trim()) : [];
                  if (!currentTags.includes(tag)) {
                    setTags([...currentTags, tag].join(', '));
                  }
                }}
              >
                #{tag}
              </button>
            ))}
          </div>
        </div>

        {/* 摘要 */}
        <div className="form-section">
          <label className="form-label">
            <span className="label-icon">📄</span>
            文章摘要
          </label>
          <textarea
            className="form-textarea excerpt-input"
            placeholder="输入文章摘要（可选）"
            value={excerpt}
            onChange={(e) => setExcerpt(e.target.value)}
            rows={3}
          />
        </div>

        {/* 内容编辑器 */}
        <div className="form-section">
          <label className="form-label">
            <span className="label-icon">📝</span>
            文章内容
          </label>
          <EditorToolbar onFormat={formatText} />
          <textarea
            id="content-editor"
            className="form-textarea content-editor"
            placeholder="开始撰写你的文章...（支持Markdown格式）"
            value={content}
            onChange={(e) => setContent(e.target.value)}
            rows={20}
            required
          />
          <div className="editor-help">
            <p className="help-title">
              <span className="help-icon">💡</span>
              写作提示：
            </p>
            <ul className="help-tips">
              <li>使用工具栏或Markdown语法格式化文本</li>
              <li>添加图片：![描述](图片URL)</li>
              <li>添加链接：[文本](URL)</li>
              <li>保持段落清晰，适当使用标题</li>
            </ul>
          </div>
        </div>

        {/* 发布选项 */}
        <div className="form-section publish-section">
          <div className="publish-options">
            <label className="option-checkbox">
              <input type="checkbox" defaultChecked />
              <span>设为精选文章</span>
            </label>
            <label className="option-checkbox">
              <input type="checkbox" defaultChecked />
              <span>允许评论</span>
            </label>
          </div>

          <div className="form-actions">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => navigate(-1)}
              disabled={isSubmitting}
            >
              <span className="btn-icon">←</span>
              取消
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <span className="btn-icon">⏳</span>
                  发布中...
                </>
              ) : (
                <>
                  <span className="btn-icon">🚀</span>
                  立即发布
                </>
              )}
            </button>
          </div>
        </div>
      </form>

      {/* 写作助手 */}
      <div className="writing-assistant">
        <div className="assistant-header">
          <span className="assistant-icon">😺</span>
          <h3>猫咪写作助手</h3>
        </div>
        <div className="assistant-content">
          <p>写作时记得：</p>
          <ul>
            <li>👁️‍🗨️ 确保信息准确</li>
            <li>💖 分享真实体验</li>
            <li>📷 配图更吸引人</li>
            <li>🎯 专注一个主题</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default WritePost;